var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDashboardLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Dashboard and Statistics",
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 120
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 5525",
  d: "M0 0h120v120H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 10623",
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 280315",
  d: "M82.745 85.502a2 2 0 0 0-2.112 2.113v4.444H35.978V27.936h30.267v12.279a2 2 0 0 0 2.116 2.116h12.272v5.079a2.116 2.116 0 1 0 4.233 0v-7.195a1.273 1.273 0 0 0-.212-.847c-.212-.212-.212-.423-.423-.635L69.84 24.338c-.212-.212-.423-.423-.635-.423H33.861a2 2 0 0 0-2.116 2.116v68.36a2 2 0 0 0 2.116 2.116h48.884a2 2 0 0 0 2.116-2.116V87.83a1.959 1.959 0 0 0-2.116-2.328m-12.063-54.6 7.2 7.2h-7.2Z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 280316",
  d: "M75.769 50.582a18.039 18.039 0 0 0-4.868.635H43.385a2.116 2.116 0 0 0 0 4.233h20.529a17.061 17.061 0 0 0-3.809 5.5h-16.72a2.116 2.116 0 0 0 0 4.233h15.45a10.3 10.3 0 0 0-.212 2.54 8.227 8.227 0 0 0 .423 3.175H43.385a2.116 2.116 0 0 0 0 4.233h17.143a15.968 15.968 0 0 0 4.444 5.5H43.597a2.116 2.116 0 0 0 0 4.233h31.322a1.272 1.272 0 0 0 .85-.208h.212a17.155 17.155 0 0 0 1.266-34.286 4.132 4.132 0 0 1-1.478.212m0 29.841a12.91 12.91 0 1 1 12.91-12.91 12.961 12.961 0 0 1-12.91 12.91"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 280317",
  d: "m81.265 60.529-8.677 8.889-2.323-2.324a2.1 2.1 0 0 0-2.963 2.963l3.809 4.021a2.046 2.046 0 0 0 2.963 0l10.157-10.584a2.046 2.046 0 0 0 0-2.963c-.635-.847-1.9-.847-2.963 0"
}))));
export default SvgDashboardLogo;